module.exports = __webpack_public_path__ + "static/media/img3-2.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/nutricheck_foliar/CA/img3-2.png
// module id = 2135
// module chunks = 3